<div class="login">
  <div class="login-container">
    <div class="login-card">
      <div class="login-left">
        <!-- Ajoutez des styles de dégradé ou une image en arrière-plan -->
      </div>
      <div class="login-right">
        <div class="blocTop">
          <div>
            <img src="assets/img/logo.png" alt="SynthIA Logo" class="logo" />
          </div>
          <div>
            <img src="assets/img/logo_police_bleue.png" alt="SynthIA name" class="logot" />
          </div>
        </div>
        @if (!isSubmitted) {
          <div>
            <div class="titleCo">
              Mot de passe oublié
            </div>
            <div >
              <form (submit)="login()" [formGroup]="loginForm">
                <div class="form-group">
                  <input type="email" class="form-control" name="email" formControlName="email" id="email"
                    aria-describedby="email" placeholder="Votre adresse email professionnelle" >
                </div>
                <button type="submit" class="btn-connect" >Reinitialiser mon mot de passe</button>
              </form>
            </div>
            <div class="text-center advert">
              La réinitialisation de votre mot de passe ne sera effective que si votre compte n'est pas bloqué par votre administrateur.<br />
              Pour des raisons de sécurité, toute tentative abusive entraînera le blocage de votre adresse IP.
            </div>
          </div>
        }
        @if (isSubmitted) {
          <div>
            <div class="text-center">
              <p>
                Si l'adresse e-mail que vous avez renseignée est bien associée à un compte, un e-mail de réinitialisation de mot de passe vous sera envoyé dans quelques instants.
              </p>
              <p>
                Merci de vérifier votre boîte de réception ainsi que vos courriers indésirables.
              </p>
              <p>
                Vous allez être redirigé vers la page de connexion dans quelques secondes...
              </p>
            </div>
          </div>
        }
        <div class="text-center retrunCo">
          <a href="/login">Page de connexion</a>
        </div>
      </div>
    </div>
  </div>
</div>